module.exports = __webpack_public_path__ + "static/media/move_CONTAINER.4e7145a2.svg";